import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  IconEnvelope,
  IconHelp,
  IconPhone,
  InformationBlockLabelAlt,
  IconClock,
  Link,
} from '@klarna/bubble-ui';
import { selectors as i18nSelectors, translator } from 'mage-i18n';

import { Footer, FooterElement } from '@/components';

import {
  getCountryMosEmail,
  getCountrySupportPhone,
  getKlarnaDotComSupportLink,
  isMerchantOnboardingCompleted,
  isPreAssessmentMerchant,
} from '@/selectors/merchant';

import {
  getPartnerCountrySupportEmail,
  getPartnerCountrySupportPhone,
  getPartnerCountryOpeningHours,
} from '@/selectors/options';

import { isUnmanagedKyc } from '@/selectors/widget';

const tPrefix = 'products-fe.components.support_footer';

const SupportFooter = ({
  t,
  isMerchantOnboardingCompleted,
  isPreAssessmentMerchant,
  merchantId,
  supportEmail,
  supportLink,
  supportPhone,
  openingHours = undefined,
}) => (
  <Footer>
    {!isPreAssessmentMerchant && (
      <>
        {isMerchantOnboardingCompleted ? (
          <FooterElement icon={<IconHelp />}>
            <Link
              textToken="text-style/text/labels/body/medium"
              key={supportLink}
              href={supportLink}
              target="_blank"
            >
              {t(`${tPrefix}.support_link`)}
            </Link>
          </FooterElement>
        ) : (
          <FooterElement icon={<IconEnvelope />}>
            <Link
              textToken="text-style/text/labels/body/medium"
              key={supportEmail}
              href={`mailto:${supportEmail}`}
              target="_self"
            >
              {supportEmail}
            </Link>
          </FooterElement>
        )}
        {supportPhone && (
          <FooterElement icon={<IconPhone />}>
            <Link
              textToken="text-style/text/labels/body/medium"
              key={`${supportPhone}`}
              href={`tel:${supportPhone}`}
              target="_self"
            >
              {supportPhone}
            </Link>
          </FooterElement>
        )}
      </>
    )}
    {openingHours && <FooterElement icon={<IconClock />}>{openingHours}</FooterElement>}
    <FooterElement>
      <InformationBlockLabelAlt>
        {t(`${tPrefix}.merchant_id`, { merchantId })}
      </InformationBlockLabelAlt>
    </FooterElement>
  </Footer>
);

SupportFooter.propTypes = {
  isMerchantOnboardingCompleted: PropTypes.bool.isRequired,
  isPreAssessmentMerchant: PropTypes.bool.isRequired,
  merchantId: PropTypes.string.isRequired,
  supportLink: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  openingHours: PropTypes.string,
  supportEmail: PropTypes.string,
  supportPhone: PropTypes.string,
};

export default connect(state => {
  const language = i18nSelectors.language(state);

  return {
    t: translator(state),
    isMerchantOnboardingCompleted: isMerchantOnboardingCompleted(state),
    isPreAssessmentMerchant: isPreAssessmentMerchant(state),
    supportEmail: !isUnmanagedKyc(state)
      ? getPartnerCountrySupportEmail(language)(state)
      : getCountryMosEmail(state),
    supportLink: getKlarnaDotComSupportLink(state),
    supportPhone: !isUnmanagedKyc(state)
      ? getPartnerCountrySupportPhone(language)(state)
      : getCountrySupportPhone(state),
    openingHours: !isUnmanagedKyc(state) ? getPartnerCountryOpeningHours(language)(state) : '',
  };
})(SupportFooter);
